module.exports = __webpack_public_path__ + "static/media/IMG_7144.2028ffe4.jpg";